// Cloudflare R2 Image Loader
// Images are fetched from R2 bucket via URLs
// Naming convention: cover.jpg and 001.jpg through 999.jpg

// Get the R2 bucket URL from environment variables (remove trailing slash)
//const R2_BUCKET_URL = (process.env.REACT_APP_R2_BUCKET_URL || 'https://pub-your-bucket-id.r2.dev').replace(/\/$/, '');
const R2_BUCKET_URL = 'https://pub-83d62ce741a14038a0c2d68c529b6538.r2.dev';
// Mapping of section IDs to folder names
// IMPORTANT: These must EXACTLY match your folder names in R2 (case-sensitive!)
export const sectionFolders = {
  0: 'Mt. Rainier 2022',
  1: 'Key West 2024',
  2: 'California 2024',
  3: 'Japan 2024',
  4: 'NYC Marathon 2024',
  5: 'Europe 2025',
  6: 'Puerto Rico 2026'
};

// Number of media in each gallery (excluding cover)
// Format: [videoCount, imageCount]
// Videos are named: 000.mp4, 001.mp4, etc.
// Images are named: 001.jpg, 002.jpg, etc.
const galleryMediaCounts = {
  'Mt. Rainier 2022': [0, 43],
  'Key West 2024': [3, 61],
  'California 2024': [5, 78],
  'Japan 2024': [4, 100],
  'NYC Marathon 2024': [1, 34],
  'Europe 2025': [0, 72],
  'Puerto Rico 2026': [1, 65] //jessica videos, reorder them
}

// Helper function to build R2 URL
const buildR2Url = (folderName, filename) => {
  // R2 expects spaces as %20
  const path = `${folderName}/${filename}`.replace(/ /g, '%20');
  return `${R2_BUCKET_URL}/${path}`;
};

// Helper function to generate numbered filename for images (001.jpg, 002.jpg, etc.)
const generateNumberedFilename = (number) => {
  return `${String(number).padStart(3, '0')}.jpg`;
};

// Helper function to generate numbered filename for videos (000.mp4, 001.mp4, etc.)
const generateNumberedVideoFilename = (number) => {
  return `${String(number).padStart(3, '0')}.mp4`;
};

// Function to get all media (videos + images) from a specific gallery folder
// Function to get all media (videos + images) from a specific gallery folder
// Videos are loaded first, then images
// Naming convention: 000.mp4, 001.mp4, ... for videos; 001.jpg, 002.jpg, ... for images
export const getGalleryImages = (folderName) => {
  const mediaCounts = galleryMediaCounts[folderName];
  
  if (!mediaCounts) {
    console.warn(`No media count found for folder: ${folderName}`);
    return [];
  }

  const [videoCount, imageCount] = mediaCounts;
  const allMedia = [];

  // Add videos first (000.mp4, 001.mp4, etc.)
  for (let i = 0; i < videoCount; i++) {
    const filename = generateNumberedVideoFilename(i);
    allMedia.push({
      src: buildR2Url(folderName, filename),
      type: 'video',
      filename: filename
    });
  }

  // Add images (001.jpg, 002.jpg, etc.)
  for (let i = 1; i <= imageCount; i++) {
    const filename = generateNumberedFilename(i);
    allMedia.push({
      src: buildR2Url(folderName, filename),
      type: 'image',
      filename: filename
    });
  }

  return allMedia;
};

// Function to get images for a specific section
export const getImagesForSection = (sectionId) => {
  const folderName = sectionFolders[sectionId];
  if (!folderName) {
    console.warn(`No folder mapping found for section ${sectionId}`);
    return [];
  }
  
  return getGalleryImages(folderName);
};

// Function to get section IDs in reverse order (so section 0 is displayed last)
export const getSectionIdsInDisplayOrder = () => {
  const sectionIds = Object.keys(sectionFolders).map(Number).sort((a, b) => a - b);
  return sectionIds.reverse();
};
